import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const path = `m27.9,
    42l1.03-2.56.63.25c.36.14.77-.03.91-.39l.11-.28c.14-.36-.03-.77-.39-.91l-.63-.25.39-.97.63.25c.36.14.77-.03.91-.39l6.16-15.35c.14-.36-.03-.77-.39-.91l-14.07-5.64c-.36-.14-.77.03-.91.39l-6.16,
    15.35c-.14.36.03.77.39.91l.63.25-.39.97-.63-.25c-.36-.14-.77.03-.91.39l-.11.28c-.14.36.03.77.39.91l.63.25-1.29,
    3.22c-.14.35.03.76.38.9l1.28.51c.35.14.75-.03.9-.38l1.29-3.22,2.56,1.03-.52,1.29,2.56,1.03.52-1.29,2.56,1.03-1.29,
    3.21c-.05.13-.05.25-.03.38H8v2h32v-2h-12.1Zm-7.36-7.61c-.14.35-.54.53-.9.38-.35-.14-.53-.54-.38-.9-.14.35-.54.53-.9.38-.35-.14-.53-.54-.38-.9.14-.35.54-.53.9-.38.35.14.53.54.38.9.14-.35.54-.53.9-.38.35.14.53.54.38.9Zm5.51,
    2.95c-.35-.14-.53-.54-.38-.9.14-.35.54-.53.9-.38.35.14.53.54.38.9.14-.35.54-.53.9-.38.35.14.53.54.38.9-.14.35-.54.53-.9.38-.35-.14-.53-.54-.38-.9-.14.35-.54.53-.9.38Zm-14.42-21.35h-3.04c.38-1.32.9-2.5,
    1.57-3.55.67-1.05,1.46-2.02,2.35-2.92,3.09-3.09,6.86-4.63,11.31-4.63s8.23,1.54,11.31,4.63l1.52,
    1.52v-5.66h2.76v10.54h-10.54v-2.83h5.59l-1.45-1.45c-2.52-2.52-5.59-3.78-9.19-3.78s-6.67,1.26-9.19,
    3.78c-.68.68-1.27,1.4-1.75,2.14-.48.74-.9,1.48-1.26,2.21Z`

/**
 * Stateless function representing a trailer RSS icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <TrailerRssIcon width={48} />
 */
const TrailerRssIcon = props => (
    <SvgIcon {...props}>
        <path d={path} />
    </SvgIcon>
)

TrailerRssIcon.defaultProps = defaultProps

export { TrailerRssIcon }
